/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

(function($) {

  /* Loading Overlay */
  $.fn.isLoading = function(){
      return $(this).hasClass('is-loading');
  };
  $.fn.addLoadingOverlay = function(){
      if(!$(this).isLoading()){
        $(this).addClass('is-loading').append('<div class="loading"><i class="fa fa-spinner fa-pulse fa-2x"></i></div>');
      }
  };

  $.fn.removeLoadingOverlay = function(){
      $(this).removeClass('is-loading').find('.loading').remove();
  };

})(jQuery); // Fully reference jQuery after this point.
/*
function bindExpertPopup(elem){
    jQuery(elem).magnificPopup({
        type: 'ajax',
        tLoading: '<span></span><span></span><span></span><span></span>',
        fixedContentPos: true,
        callbacks: {
            parseAjax: function(mfpResponse) {
                mfpResponse.data = jQuery(mfpResponse.data).find('.single-expert');
                mfpResponse.data.find( '.experts-carousel .expert .thumbnail a, .experts-carousel .expert .title a' ).each( function() {
                    jQuery(this).magnificPopup({
                        type: 'ajax',
                        tLoading: ' ',
                        fixedContentPos: true,
                        callbacks: {
                            parseAjax: function(mfpResponse) {
                                mfpResponse.data = jQuery(mfpResponse.data).find('.single-expert');
                            }
                        }
                    });
                });
            },
            ajaxContentAdded: function() {
                jQuery('.owl-carousel').owlCarousel({
                    loop: false,
                    dots: false,
                    margin: 10,
                    nav: true,
                    navText : ["<span class='prev-arrow'></span>","<span class='next-arrow'></span>"],
                    responsive:{
                        0:{
                            items:1
                        },
                        600:{
                            items:3
                        },
                        1000:{
                            items:5
                        }
                    }
                });
            }
        }
    });
}
*/

jQuery(document).ready(function($) {

    $("article .entry-content").fitVids();

    $('.carousel').carousel();
    $('.carousel').bcSwipe({ threshold: 50 });

    $('.full-container.has-link, .bottom-bar .nav li, .archive.post-type-archive-expert .experts-filter .nav li, .archive.tax-expert-category .experts-filter .nav li, .archive.post-type-archive-tribe_events .event-cats .event-cat, .page-header .carousel .carousel-item.has-link').click(function(e){
        if(e.target.nodeName.toLowerCase() !== 'a' && $(this).find('a').length){
            window.location = $(this).find('a').attr('href');
            e.preventDefault();
            return false;
        }
    });

    $(window).load(function(){
        if ( typeof jQuery.fn.counterUp !== 'undefined' ) {
            jQuery('.counter').counterUp({
                delay: 10,
                time: 2000
            });
        }
    });

    // $('.posts-wrapper .expert-wrapper .expert-popup').each(function() {
    //     bindExpertPopup(this);
    // });

    $('.open-gallery-popup-link').magnificPopup({
      type: 'inline',
      gallery: {
        enabled: true
      }
    });

    jQuery('.expert-gallery').owlCarousel({
      loop: false,
      dots: false,
      margin: 10,
      nav: true,
      stagePadding: 1,
      navText : ["<span class='prev-arrow'></span>","<span class='next-arrow'></span>"],
      responsive:{
          0:{
              items: 1,
              nav: false,
              dots: true
          },
          480:{
            items: 2,
            nav: false,
            dots: true
          },
          640:{
            items: 3
          }
        }
    });

    jQuery('.experts-owl-carousel').owlCarousel({
        loop: false,
        dots: false,
        margin: 20,
        nav: true,
        navText : ["<span class='prev-arrow'></span>","<span class='next-arrow'></span>"],
        stagePadding: 1,
        responsive:{
            0:{
                items:2,
                dots: true
            },
            400:{
              items:3,
              margin: 30
            },
            600:{
                items:4,
                margin: 30
            },
            800:{
              items:5,
              margin: 30
            },
            1000:{
                items:7,
                margin: 40
            }
        }
    });
});
